import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NoAccess } from "../equipment/shared/NoAccess";
import SchedulePage from "./SchedulePage";
import EntriesPage from "./EntriesPage";
import DueMatrixPage from "./DueMatrixPage";
import { VIEW_ROLES } from "./shared";

const TABS = [
  { key: "schedule", label: "Schedule", Component: SchedulePage },
  { key: "entries", label: "Entries", Component: EntriesPage },
  { key: "due-matrix", label: "Due Matrix", Component: DueMatrixPage },
];
const STORE_KEY = "service_tracker_tab";

// One sidebar entry, three tabs. The tab lives in the URL (/service-tracker/:tab) and the last
// one used is remembered for the session so the bare /service-tracker link reopens it.
export default function ServiceTrackerPage() {
  const { user } = useAuth();
  const { tab } = useParams();
  const navigate = useNavigate();

  if (!VIEW_ROLES.includes(user?.role)) return <NoAccess />;

  const active = TABS.find((t) => t.key === tab);
  if (!active) {
    const saved = sessionStorage.getItem(STORE_KEY);
    return <Navigate to={`/service-tracker/${TABS.some((t) => t.key === saved) ? saved : TABS[0].key}`} replace />;
  }
  sessionStorage.setItem(STORE_KEY, active.key);

  return (
    <div className="space-y-6" data-testid="service-tracker-module">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Service Tracker</h1>
        <p className="text-sm text-slate-500">Oil and filter service tracking for Piling rigs.</p>
      </div>
      <Tabs value={active.key} onValueChange={(v) => navigate(`/service-tracker/${v}`)}>
        <TabsList>
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`service-tracker-tab-${t.key}`}>{t.label}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <active.Component />
    </div>
  );
}
